import shaderFragment from '../../shaders/glows/fragment.glsl'
import shaderVertex from '../../shaders/glows/vertex.glsl'

export default {
    uniforms: {
        tDiffuse: { value: null },
        uPosition: { value: null },
        uRadius: { value: null },
        uColor: { value: null },
        uAlpha: { value: null }
    },
    vertexShader: shaderVertex,
    fragmentShader: shaderFragment
}
